import React, { useState, useCallback, useTransition } from 'react';
import ClientManagement, { ClientSelection } from './ClientManagement';
import ExportCSV from '../../reusable/Client/ExportCSV';
import MonthFilter from '../../reusable/Client/MonthFilter';
import { useTranslation } from 'react-i18next';
import { businessMonthRange } from 'config/time';

const Client: React.FC = () => {
  const { t } = useTranslation('client');
  // ADM-05。月の範囲は業務時間帯（会社の時間帯）の業務日（YYYY-MM-DD）。MonthFilter と同じ作り方にする。
  const initialDateRange = businessMonthRange();

  const [dateRange, setDateRange] = useState(initialDateRange);
  const [showClientHour, setShowClientHour] = useState(true);
  // ADM-12。CSV も一覧・グラフと同じ作業・配送先の選択で出す。
  const [selection, setSelection] = useState<ClientSelection>({
    taskId: null,
    clientIds: [],
  });

  const handleDateRangeChange = useCallback(
    (range: { start: string; end: string }) => {
      setDateRange(range);
    },
    []
  );

  const handleClientHourChange = (value: boolean) => {
    setShowClientHour(value);
  };

  return (
    <section className="px-4 py-3 space-y-3">
      <div className="flex justify-between">
        <h6 className="font-bold text-title">{t('title')}</h6>
        <div className="flex flex-row space-x-2 items-center">
          <MonthFilter onDateRangeChange={handleDateRangeChange} />
          {/* Pass dateRange and showClientHour to ExportCSV */}
          <ExportCSV
            dateRange={dateRange}
            showClientHour={showClientHour}
            selection={selection}
          />
        </div>
      </div>
      <div className="bg-white rounded-md p-4">
        <ClientManagement
          dateRange={dateRange}
          onClientHourChange={handleClientHourChange}
          onSelectionChange={setSelection}
        />
      </div>
    </section>
  );
};

export default Client;
